import { LatestNotification, LocalDate, SCode, StatusAcceptanceType } from '../../..';

export class StatusHistoryModel {
  acceptanceType: StatusAcceptanceType = null;
  statusCode: SCode = null;
  statusCodeDescription: string;
  statusDateTime: LocalDate | number;
  transactionDateTime: LocalDate | number;
  latestNotification: LatestNotification;

  constructor(params?: StatusHistoryModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
